import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="breadcrumbs"
export default class extends Controller {
  initialize() {
    window.breadcrumbsIndex = 0
    window.breadcrumbs = {}

    const breadcrumbsContainer = document.querySelector('#breadcrumbs-container')
    if (breadcrumbsContainer) {
      window.breadcrumbsIndex = 1
      window.breadcrumbs[1] = breadcrumbsContainer.innerHTML
    } else {
      window.breadcrumbsIndex = 0
    }
  }

  // Takes inner DOM of the element with data-controller="breadcrumbs" and place
  // it inside the breadcrumbs container.
  //
  // If multiple connections are made, the last one will be the one that is displayed.
  //
  // All previous connections will however still be remembered and when the last
  // one is disconnected the previous one will be displayed instead.
  connect() {
    this.breadcrumbsId = this.newBreadcrumbId()
    window.breadcrumbs[this.breadcrumbsId] = this.element.innerHTML
    this.renderBreadcrumbs()
  }

  // Removes this breadcrumb from the memory and rerenders the breadcrumbs
  // container to use the last one.
  disconnect() {
    delete window.breadcrumbs[this.breadcrumbsId]
    this.renderBreadcrumbs()
  }

  // Renders the breadcrumbs container with the last breadcrumb in memory.
  renderBreadcrumbs() {
    const breadcrumbsContainer = document.querySelector('#breadcrumbs-container')
    if (!breadcrumbsContainer) return

    const breadcrumbIds = Object.keys(window.breadcrumbs)
    if (breadcrumbIds.length === 0) {
      breadcrumbsContainer.innerHTML = ''
      return
    }

    const highestBreadcrumb = Math.max(...breadcrumbIds.map(Number))
    breadcrumbsContainer.innerHTML = window.breadcrumbs[highestBreadcrumb]
  }

  // Increments the breadcrumbs index and retrieves the next one to be used.
  newBreadcrumbId() {
    return window.breadcrumbsIndex += 1
  }
}
